<template>
  <router-link
    v-if="menuItem.to"
    :class="componentClasses"
    :to="menuItem.disabled ? '#' : menuItem.to"
    :disabled="menuItem.disabled"
  >
    <Icon
      class="sidenav-link-icon"
      :icon="menuItem.icon"
    />
    <span class="sidenav-link-label">
      {{ menuItem.label }}
    </span>
    <Icon
      class="sidenav-link-arrow"
      icon="fas fa-arrow-right"
    />
  </router-link>
  <a
    v-else
    class="sidenav-link"
    :href="menuItem.href"
    :target="menuItem.target"
  >
    <Icon
      class="sidenav-link-icon"
      :icon="menuItem.icon"
    />
    <span class="sidenav-link-label">
      {{ menuItem.label }}
    </span>
    <Icon
      v-if="menuItem.iconAfter"
      class="sidenav-link-arrow"
      :icon="menuItem.iconAfter"
    />
  </a>
</template>

<script setup>
import { computed } from 'vue';
import { Icon, StakeTooltip } from '@stakeui';

const props = defineProps({
  menuItem: {
    type: Object,
    required: true,
  },
});

const componentClasses = computed(() => [
  'sidenav-link',
  {
    [`is-${props.menuItem.variant}`]: props.menuItem.variant,
    [`is-disabled`]: props.menuItem.disabled,
  },
]);
</script>

<style>
.sidenav-link {
  --color: var(--stk-primary);
  border-radius: 0.5em;
  display: flex;
  align-items: center;
  gap: 0.5em;
  padding: 0.375em 0.75em;
  position: relative;
  transition-duration: var(--stk-transition-duration);
  transition-property: opacity;

  &:hover,
  &.router-link-active,
  &.router-link-exact-active {
    .sidenav-link-label {
      color: var(--stk-text-10);
    }

    .sidenav-link-arrow {
      opacity: 1;
      transform: none;
    }
  }

  &.is-disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &.router-link-active,
  &.router-link-exact-active {
    background-color: #fff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.05), 0px 1px 0px 0px rgba(0, 0, 0, 0.05);;
  }

  &.is-valuescore {
    --color: #CF67EF;
  }
}

.sidenav-link-icon {
  color: var(--stk-text-70);
}

.sidenav-link-label {
  font-size: 0.9375em;
  font-weight: 500;
  color: var(--stk-text-30);
  line-height: 1.25rem;
  transition-duration: var(--stk-transition-duration);
  transition-property: color;
}

.sidenav-link-arrow {
  color: var(--color);
  position: absolute;
  pointer-events: none;
  right: 0.5em;
  opacity: 0;
  transform: translateX(-0.25em);
  transition-duration: var(--stk-transition-duration);
  transition-property: color, opacity, transform;
}
</style>
